module.exports = __webpack_public_path__ + "img/Elektroversorgung.42a7a2e4.svg";